/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a1f05dcc-008c-43aa-9332-e8aecda324ce",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_7IEK5GwJv",
    "aws_user_pools_web_client_id": "6o9iu9le83btaho9sgcei7qi2m",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "TranscriberConfig-yjw4voi4ujhe7cit5pi3jnaety-vadev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "va-smartscribe-audio-conversion155305-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://gqm2iy3t25edza2h3ntxyqfway.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kpkdb5m2jfb3boiw7h4ufqmi5u"
};


export default awsmobile;
